import baseApi from 'shared/api/baseApi';

import { SignInBody, User, UserPermissions } from '../types/user';

type RefreshSessionResponse = { accessToken: string; tokenType: string };

const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    signInUser: build.mutation<User, SignInBody>({
      query: (body) => ({
        url: '/auth',
        method: 'POST',
        body,
      }),
    }),
    getUserPermissions: build.query<UserPermissions, number | null>({
      query: () => ({
        url: '/user/permissions',
        method: 'GET',
      }),
      providesTags: ['UserPermissions'],
    }),
    refreshSession: build.mutation<RefreshSessionResponse, void>({
      query: () => ({
        url: '/auth/refresh',
        method: 'POST',
      }),
    }),
    logoutUser: build.mutation<void, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSignInUserMutation, useGetUserPermissionsQuery, useRefreshSessionMutation, useLogoutUserMutation } =
  authApi;
